module.exports = __webpack_public_path__ + "dingbeauty-build/img/no-record.99668315.svg";